import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@data/store';

export const deliveryReceiptDocumentSelector = () =>
  createSelector(
    [(state: RootState) => state],
    state => state.deliveryReceiptDocument || null
  );
